import React, { Component } from 'react';
import { connect } from 'react-redux';
import { defineMessages } from "react-intl"
import CloseIcon from '@material-ui/icons/Close';
import { FormattedMessage as FormattedMessageReactIntl } from 'react-intl';

import {
  formatCurrency,
  formatPercent
} from 'shared/services/PriceService';

import messages from 'shared/messages/source/index.js';

// prepare the messages for formatjs
for (let id in messages) {
  // set the object key as the message ID
  messages[id].id = id;

  // allow HTML tags for rich text formatting.
  // formatjs supports implementing HTML tags via the values attr.
  // by default html tags aren't rendered.
  // this values object would normally be overwritten by any values passed when formatting.
  // the withValues() function can be used to merge in new values.
  // we can also use this to enable icons and arbitrary code.
  messages[id].values = {
    b: boldText => <b style={{fontWeight: 600}}>{boldText}</b>,
    i: italicText => <i>{italicText}</i>,
    CloseIcon: () => <CloseIcon />
  }
}

// use to avoid overwriting HTML tag support for rich text formatting.
// Ex: <FormattedMessage {...withValues(message, {name: user.name})} />
export const withValues = (message, values) => {
  // format percent & currency values.
  // todo: react-intl can handle this using Intl.NumberFormat
  // via the message definition. ex: "{pct, number, ::percent}"
  values = {...values};
  for (let k in values) {
    if (k === 'percent') {
      values[k] = formatPercent(values[k]);
    }
    if (k === 'price') {
      values[k] = formatCurrency(values[k], values.currency, values.show_change);
    }
  }

  return {...message, values: {...message.values, ...values}};
}

// -- <FormattedMessage />
// optional wrapper for react-intl's <FormattedMessage /> component.
// this wrapper will catch missing messages at runtime.
// without this a missing message ID would be hard to track down,
// since formatjs's runtime error doesn't show the location of the message.
// this also has access to the redux state and implements the uppercase flag.
// this also handles messages with only IDs (ex: our server generated ones).
class FormattedMessageClass extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { id, settings, values, defaultMessage } = this.props;

    if (!id) {
      console.error('Missing "id" field in FormattedMessage props. Message location will appear with a red warning.');
      let style = {color: 'red', fontWeight: 700};
      return <span style={style}>MISSING MESSAGE</span>;
    }

    let message;
    if (!defaultMessage) {
      message = {...messages[id], ...this.props};
    } else {
      message = {...this.props};
    }

    // uppercase headers, labels & buttons if flag is set
    let uppercase = settings && settings.uppercase_labels &&
      id.match(/(header|label|button)/);

    // also allow passing uppercase: true as a value
    uppercase ||= values && values.uppercase;

    if (uppercase) {
      return (
        <span style={{textTransform: 'uppercase'}}>
          <FormattedMessageReactIntl {...message} />
        </span>
      );
    }

    return <FormattedMessageReactIntl {...message} />;
  }
}

// this is a wrapper for FormattedMessageClass.
// it's just a place to handle hotfixes at the moment
class FormattedMessageWrapper extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { id, values } = this.props;

    // hotfix - cart_digitals_and_prints doesn't render properly.
    // jerry-rigging it here.
    // oddly it does render within this block if the id isn't reset.
    // saving for another day
    if (id === 'cart_digitals_and_prints') {
      let digitalsValues = {...values, quantity: values.digitals};
      let digitalsProps = {
        ...this.props,
        id: 'cart_digitals',
        values: digitalsValues
      };
      let digitals = <FormattedMessageClass {...digitalsProps} />;

      let printsValues = {...values, quantity: values.prints};
      let printsProps = {
        ...this.props,
        id: 'cart_prints',
        values: printsValues
      };
      let prints = <FormattedMessageClass {...printsProps} />;

      return <span>{digitals} & {prints}</span>;
    }

    return <FormattedMessageClass {...this.props} />;
  }
}

export const FormattedMessage = connect(state => ({
  settings: state.messagesReducer
}))(FormattedMessageWrapper);

export default defineMessages(messages);
